import { BeIconView, type BeIconViewItem, BeRow, BeStack, BeText } from "@beos-css/react/index.ts";
import { useState } from "react";
import iconBeide from "../../icons/beide.png";
import iconBeide32 from "../../icons/beide-32.png";
import iconFolder from "../../icons/folder.png";
import iconFolder32 from "../../icons/folder-32.png";
import iconPeople from "../../icons/people.png";
import iconPeople32 from "../../icons/people-32.png";
import iconQuickres from "../../icons/quickres.png";
import iconQuickres32 from "../../icons/quickres-32.png";
import iconSoundRecorder from "../../icons/soundrecorder.png";
import iconSoundRecorder32 from "../../icons/soundrecorder-32.png";
import iconTerminal from "../../icons/terminal.png";
import iconTerminal32 from "../../icons/terminal-32.png";

const items: BeIconViewItem[] = [
	{ id: "beide", name: "BeIDE", icon: { mini: iconBeide, large: iconBeide32 } },
	{ id: "terminal", name: "Terminal", icon: { mini: iconTerminal, large: iconTerminal32 } },
	{ id: "people", name: "People", icon: { mini: iconPeople, large: iconPeople32 } },
	{ id: "quickres", name: "QuickRes", icon: { mini: iconQuickres, large: iconQuickres32 } },
	{ id: "soundrec", name: "SoundRecorder", icon: { mini: iconSoundRecorder, large: iconSoundRecorder32 } },
	{ id: "downloads", name: "downloads", icon: { mini: iconFolder, large: iconFolder32 } },
];

export function IconViewDemo() {
	const [sel, setSel] = useState<string[]>(["terminal"]);
	const select = (id: string) => setSel([id]);

	return (
		<section id="demo-icon-view">
			<h2>Icon view (BeIconView) -- Tracker's Icon and Mini Icon modes</h2>
			<p>
				The same items BeTable draws as rows, laid out on Tracker's snap grid instead. Click to select: the name inverts and the icon
				darkens with it, and "SoundRecorder" shows how a long label overruns its own 60px track rather than being clipped to it.
			</p>
			<BeRow wrap gap="row">
				<BeStack gap="tight">
					<BeText face="mini">Icon View -- 60x60</BeText>
					<BeIconView items={items} selectedIds={sel} onSelectItem={select} />
				</BeStack>

				<BeStack gap="tight">
					<BeText face="mini">Mini Icon View -- 96x20</BeText>
					<BeIconView mode="mini" items={items} selectedIds={sel} onSelectItem={select} />
				</BeStack>

				<BeStack gap="tight">
					<BeText face="mini">read-only -- no onSelectItem</BeText>
					<BeIconView items={items.slice(0, 3)} />
				</BeStack>
			</BeRow>
		</section>
	);
}
